import React from 'react'
import { Card, Group, Text, Switch, Stack, Grid, NumberInput, ActionIcon, Button } from '@mantine/core'
import { IconPlus, IconTrash } from '@tabler/icons-react'

const WholesaleRateCard = ({ method, rates, onRateChange }) => {
    const currentMethodRates = rates[method] || {}
    const isWholesale = currentMethodRates.is_wholesale || false
    const wholesalePrices = currentMethodRates.wholesale_prices || []
    const currency = currentMethodRates.currency || ''

    return (
        <Card withBorder mt="sm" p="lg" radius="md">
            <Group justify="space-between" mb="md">
                <Text fw={700}>Wholesale Rate</Text>
                <Switch
                    checked={isWholesale}
                    onChange={(event) => onRateChange(method, 'is_wholesale', event.currentTarget.checked)}
                />
            </Group>

            {isWholesale && (
                <Stack>
                    {wholesalePrices.map((tier, index) => (
                        <Grid key={index} align="flex-end">
                            <Grid.Col span={5}>
                                <NumberInput
                                    label="Minimum Quantity"
                                    placeholder="10"
                                    value={tier.min_quantity}
                                    onChange={(val) => {
                                        const newTiers = [...wholesalePrices]
                                        newTiers[index] = { ...newTiers[index], min_quantity: val }
                                        onRateChange(method, 'wholesale_prices', newTiers)
                                    }}
                                    min={0}
                                />
                            </Grid.Col>
                            <Grid.Col span={5}>
                                <NumberInput
                                    label="Cost"
                                    placeholder="0"
                                    value={tier.price}
                                    onChange={(val) => {
                                        const newTiers = [...wholesalePrices]
                                        newTiers[index] = { ...newTiers[index], price: val }
                                        onRateChange(method, 'wholesale_prices', newTiers)
                                    }}
                                    leftSection={<Text size="xs" c="dimmed">{currency}</Text>}
                                    hideControls
                                />
                            </Grid.Col>
                            <Grid.Col span={2}>
                                <ActionIcon
                                    color="red"
                                    variant="light"
                                    size="lg"
                                    onClick={() => {
                                        const newTiers = wholesalePrices.filter((_, i) => i !== index)
                                        onRateChange(method, 'wholesale_prices', newTiers)
                                    }}
                                >
                                    <IconTrash size={16} />
                                </ActionIcon>
                            </Grid.Col>
                        </Grid>
                    ))}
                    <Button
                        variant="light"
                        leftSection={<IconPlus size={16} />}
                        onClick={() => {
                            const newTiers = [...wholesalePrices, { min_quantity: '', max_quantity: 0, price: '' }]
                            onRateChange(method, 'wholesale_prices', newTiers)
                        }}
                    >
                        Add Tier
                    </Button>
                </Stack>
            )}
        </Card>
    )
}

export default WholesaleRateCard
